'use client';

import { FC } from 'react';
import { useSearchParams } from 'next/navigation';
import { SharedLinkBase, SharedLinkBaseProps } from './link-base';

interface SharedLinkProps extends SharedLinkBaseProps {
  keepSearchParams?: boolean;
}

export const SharedLink: FC<SharedLinkProps> = ({ keepSearchParams = true, ...props }) => {
  const searchParams: { [k: string]: string } = {};

  useSearchParams()?.forEach((value, key) => {
    searchParams[key] = value;
  });

  return <SharedLinkBase {...props} {...(keepSearchParams ? { searchParams } : null)} />;
};
